import { z } from "zod";
export const listInputSchema = z.object({
    name: z.string().min(1).max(200),
    description: z.string().nullable().optional(),
});
export const listPatchSchema = listInputSchema.partial();
export const listSchema = listInputSchema.extend({
    id: z.string(),
    memberCount: z.number().int().nonnegative(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const listMemberRefSchema = z.union([
    z.object({ contactId: z.string() }),
    z.object({ householdId: z.string() }),
]);
export const listMembersBodySchema = z.object({
    members: z.array(listMemberRefSchema).min(1),
});
//# sourceMappingURL=list.js.map